export const DISCOVER_GAMES_PAGE_SIZE_OPTIONS = [5, 10, 20, 30, 50] as const;

/** Home/away side discriminator (program game modal, games grid team columns, …). */
export const DiscoverClubTeamSide = {
	Home: "home",
	Away: "away",
} as const;

export type DiscoverClubTeamSide = (typeof DiscoverClubTeamSide)[keyof typeof DiscoverClubTeamSide];

/** Home/away club & team ids (program game form keys and discover games grid search filters). */
export enum DiscoverClubTeamFormField {
	HomeClub = "homeClub",
	HomeTeam = "homeTeam",
	AwayClub = "awayClub",
	AwayTeam = "awayTeam",
}
